import React from 'react';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { AppLayout } from '@/components/layouts/app-layout';
import { Home } from '@/pages/home';
import { Registration } from '@/pages/registration';
import { RegistrationV2 } from '@/pages/registrationV2';
import { Browse } from '@/pages/browse';
import { Messages } from '@/pages/messages';
import { Liked } from '@/pages/liked';
import { Profile } from '@/pages/profile';
import { Subscription } from '@/pages/subscription';
import { ProfileEdit } from '@/pages/profile-edit';
import { Settings } from '@/pages/settings';
import { Chat } from '@/pages/chat';
import { RegistrationLayout } from '@/components/layouts/registration-layout';
import { PrivateRoutes } from '@/components/private-routes';
import { AuthProvider } from '@/components/auth-provider';
import { TgProvider } from '@/components/tg-provider';
import { ProfileView } from '@/pages/profile-view';
import TermsOfService from '@/pages/terms-of-service/terms-of-service';
import { IntroBanned } from '@/components/intro/intro-banned';
import { MyFormPreview } from '@/pages/my-form-preview';
import { RegistrationV3 } from '@/pages/registrationV3';
import { RegistrationV4 } from '@/pages/registrationV4';
import { RegistrationLayoutV2 } from '@/components/layouts/registration-layout-v2';
import { RegistrationLayoutV4 } from '@/components/layouts/registration-layout-v4';
import { WebSub } from '@/pages/web-sub';
import { IntroWeb } from '@/components/intro/introWeb/introWeb';
import { NavHostProvider } from '@/components/nav-host-provider';

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<NavHostProvider />}>
            <Route path={routesApp.index} element={<IntroWeb />} />
            <Route element={<AuthProvider />}>
                <Route element={<TgProvider />}>
                    <Route path={routesApp.home} element={<Home />} />
                    <Route element={<RegistrationLayout />}>
                        <Route path={routesApp.registration} element={<Registration />} />
                    </Route>
                    <Route element={<RegistrationLayoutV2 />}>
                        <Route path={routesApp.registrationV2} element={<RegistrationV2 />} />
                    </Route>
                    <Route element={<RegistrationLayoutV2 />}>
                        <Route path={routesApp.registrationV3} element={<RegistrationV3 />} />
                    </Route>
                    <Route element={<RegistrationLayoutV4 />}>
                        <Route path={routesApp.registrationV4} element={<RegistrationV4 />} />
                    </Route>
                    {/* </Route> */}
                    <Route element={<PrivateRoutes />}>
                        <Route element={<AppLayout />}>
                            <Route
                                path={routesApp.browse}
                                element={<Browse key={routesApp.browse} />} />
                            <Route
                                path={routesApp.messages}
                                element={<Messages key={routesApp.messages} />} />
                            <Route
                                path={routesApp.liked}
                                element={<Liked key={routesApp.liked} />} />
                            <Route
                                path={routesApp.profile}
                                element={<Profile key={routesApp.profile} />} />
                            <Route
                                path={routesApp.subscription}
                                element={<Subscription key={routesApp.subscription} />} />
                            <Route
                                path={routesApp.webSub}
                                element={<WebSub key={routesApp.webSub} />} />
                            <Route
                                path={routesApp.profileEdit}
                                element={<ProfileEdit key={routesApp.profileEdit} />} />
                            <Route
                                path={routesApp.settings}
                                element={<Settings key={routesApp.settings} />} />
                            <Route path={routesApp.profileView} element={<ProfileView />} />
                            <Route path={routesApp.termsOfService} element={<TermsOfService />} />

                            <Route path={routesApp.myFormPreview} element={<MyFormPreview />} />
                        </Route>
                        <Route path={routesApp.chat} element={<Chat />} />
                    </Route>
                    <Route path={routesApp.banned} element={<IntroBanned />} />
                </Route>
            </Route>
        </Route>
    ),
    { basename: '/' }
);

const Router: React.FC = () => {
    return <RouterProvider router={router} />
}

export default Router;
